import moment from 'moment';

const FORMAT_SYNC_TIMESTAMP = 'HH:mm:ss';

function emitSyncDate(comp) {
	if (comp && comp.$emit) {
		comp.$emit('updateSyncDate', moment().format(FORMAT_SYNC_TIMESTAMP));
	} else {
		// console.error('Wrong Argument : ', comp);
	}
}

export { emitSyncDate };
